import { convertToClientCountryData, convertToServerCountryData } from '@core';
export var convertToServerIssuerFilterData = function (data) { return ({
    name: data.name || null,
    countryType: convertToServerCountryData(data.countries) || null,
    logoUrl: data.logoUrl || null,
    webSite: data.webSite || null,
}); };
export var convertToServerIssuerAddData = function (data) { return ({
    name: data.name || null,
    countryTypes: convertToServerCountryData(data.countries) || null,
    formFile: data.logoFile || null,
    webSite: data.webSite || null,
}); };
export var convertToServerIssuerEditData = function (data) { return ({
    id: data.id || null,
    name: data.name || null,
    countries: convertToServerCountryData(data.countries) || null,
    formFile: data.logoFile || null,
    webSite: data.webSite || null,
}); };
export var convertToClientIssuerData = function (data) {
    var _a, _b, _c, _d, _e;
    return ({
        id: (_a = data.id) !== null && _a !== void 0 ? _a : '',
        name: (_b = data.name) !== null && _b !== void 0 ? _b : '',
        countries: (_c = convertToClientCountryData(data.countries)) !== null && _c !== void 0 ? _c : '',
        logoUrl: (_d = data.logoUrl) !== null && _d !== void 0 ? _d : '',
        webSite: (_e = data.webSite) !== null && _e !== void 0 ? _e : '',
    });
};
